import { LabelPlacement } from "prep/create/PrepInstructions/PrepInstructionsTypes";

export const inferLabelPlacement = (instructions): LabelPlacement | undefined => {
  const pattern = /Paste labels at (.+)/;
  for (const instruction of instructions) {
    const match = instruction.match(pattern);
    if (match) {
      const placement = match[1];
      return Object.values(LabelPlacement).find((value) => value === placement);
    }
  }
  return undefined;
};
